import * as React from "react";
import * as ReactDOM from "react-dom";
import {
  Route,
  Navigate,
  Routes as RoutesReact,
  useLocation,
  Outlet,
  Routes,
  useParams,
  useNavigate,
} from "react-router-dom";
import SignIn from "../containers/auth/SignIn";
import Register from "../containers/auth/Register";
import AuthService from "../services/Auth";
import Header from "./Header";
import EventsComponent from "../containers/administration/Events";
import AddBooking from "../containers/administration/AddBooking";
import Accounting from "../containers/administration/Accounting";
import Reports from "../containers/administration/Reports";
import MemberGroups from "../containers/administration/MasterData/MemberGroups";
import AgeGroups from "../containers/administration/MasterData/AgeGroups";
import EventNumbers from "../containers/administration/MasterData/EventNumbers";
import EventOptions from "../containers/administration/MasterData/EventOptions";
import PriceTypes from "../containers/administration/MasterData/PriceTypes";
import UserData from "../containers/administration/MasterData/UserData";
import EditEvent from "../containers/administration/EditEvent";
import CurrentEvents from "../containers/User/CurrentEvents";
import ChangePassword from "../containers/User/ChangePassword";
import PaidEvents from "../containers/User/PaidEvents";
import BookedEvents from "../containers/User/BookedEvents";
import AddBookingUser from "../containers/User/AddBooking";
import RegisterComplete from "../containers/auth/RegisterComplete";
import { UserRoles } from "../models/UserRoles";
import AuthStore from "../stores/Auth";
import Forgotten from "../containers/auth/Forgotten";
import Impressum from "../containers/Static/Impressum";
import UserGroupsPaymentTypes from "../containers/administration/MasterData/UserGroupsPaymentTypes";

export class RoutePaths {
  public static Home: string = "/";
  public static SignIn: string = "/signin";
  public static Register: string = "/register/";
  public static AdminEvents: string = "/admin/events";
  public static AddBooking: string = "/admin/addbooking";
  public static Accounting: string = "/admin/accounting";
  public static Reports: string = "/admin/reports";
  public static MemberGroups: string = "/admin/membergroups";
  public static AgeGroups: string = "/admin/agegroups";
  public static EventNumbers: string = "/admin/EventNumbers";
  public static EventOptions: string = "/admin/eventoptions";
  public static PriceTypes: string = "/admin/pricetypes";
  public static UserData: string = "/admin/userdata";
  public static EditEvent: string = "/admin/editevent";
  public static CurrentEvents: string = "/user/currentevents";
  public static ChangePassword: string = "/user/changepassword";
  public static PaidEvents: string = "/user/paidevents";
  public static BookedEvents: string = "/user/bookedevents";
  public static AddBookingUser: string = "/user/addbooking";
  public static RegisterComplete: string = "/emailsent";
  public static EditUser: string = "/edituser";
  public static ForgottenPass: string = "/forgottenpassword";
  public static Impressum: string = "/impressum";
  public static UserGroupsPaymentTypes = "/admin/paymenttypes";
}

export default class AppRoutes extends React.Component<any, any> {
  public static appVersion: string = "AppVersion 2.0.0";

  render() {
    return (
      <Routes>
        {/* Public */}
         <Route element={<PublicLayout />}>
          <Route path={RoutePaths.SignIn} element={<SignIn />} />
          <Route path={RoutePaths.Register} element={<Register />} />
          <Route path={RoutePaths.Home} element={<CurrentEvents />} />
          <Route
            path={RoutePaths.RegisterComplete}
            element={<RegisterComplete />}
          />
          <Route path={RoutePaths.ForgottenPass} element={<Forgotten />} />
          <Route path={RoutePaths.Impressum} element={<Impressum />} />
          <Route
            path="/Logout"
            element={<Navigate to={RoutePaths.SignIn} replace />}
          />
        </Route>

        {/* Default */}
        <Route element={<DefaultLayout />}>
          <Route path={RoutePaths.CurrentEvents} element={<CurrentEvents />} />
          <Route
            path={RoutePaths.ChangePassword}
            element={<ChangePassword />}
          />
          <Route path={RoutePaths.PaidEvents} element={<PaidEvents />} />
          <Route path={RoutePaths.BookedEvents} element={<BookedEvents />} />
          <Route
            path={RoutePaths.AddBookingUser}
            element={<AddBookingUser />}
          />
          <Route path={RoutePaths.EditUser} element={<Register />} />
        </Route>

        {/* Veranstalter */}
        <Route element={<VeranstalterLayout />}>
          <Route path={RoutePaths.AdminEvents} element={<EventsComponent />} />
          <Route path={RoutePaths.AddBooking} element={<AddBooking />} />
          <Route path={RoutePaths.Reports} element={<Reports />} />
          <Route path={RoutePaths.EditEvent} element={<EditEvent />} />
        </Route>

        {/* Admin */}
        <Route element={<AdminLayout />}>
          <Route path={RoutePaths.Accounting} element={<Accounting />} key={1}/>
          <Route path={RoutePaths.MemberGroups} element={<MemberGroups />} key={2} />
          <Route path={RoutePaths.AgeGroups} element={<AgeGroups />} key={3} />
          <Route path={RoutePaths.EventNumbers} element={<EventNumbers />} key={4} />
          <Route path={RoutePaths.EventOptions} element={<EventOptions />} key={5} />
          <Route path={RoutePaths.PriceTypes} element={<PriceTypes />} key={6} />
          <Route path={RoutePaths.UserData} element={<UserData />} key={7} />
          <Route
            path={RoutePaths.UserGroupsPaymentTypes}
            element={<UserGroupsPaymentTypes />}
            key={8}
          />
        </Route>

        {/* Optional: Catch-all */}
        <Route path="*" element={<Navigate to={RoutePaths.SignIn} />} />
      </Routes>
    );
  }
}

const DefaultLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  if (!AuthService.isSignedIn()) {
    return (
      <Navigate to={RoutePaths.SignIn} state={{ from: location }} replace />
    );
  }

  return (
    <div>
      <Header location={location} navigate={navigate} classes={""} />
      <div className="container mt-4 mb-4">
        <Outlet />
      </div>
      <footer className="footer">
        <div className="container">
          <span className="text-muted float-right">{AppRoutes.appVersion}</span>
        </div>
      </footer>
    </div>
  );
};

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
 
  if (!AuthService.isSignedIn() || !AuthService.isAdmin()) {
    return (
      <Navigate to={RoutePaths.SignIn} state={{ from: location }} replace />
    );
  }

  return (
    <div>
      <Header location={location} navigate={navigate} classes={""}  />
      <div className="container mb-4">
        <Outlet />
      </div>
      <footer className="footer">
        <div className="container">
          <span className="text-muted float-right">{AppRoutes.appVersion}</span>
        </div>
      </footer>
    </div>
  );
};

const VeranstalterLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const role = AuthStore.getRole();
 
  const isAllowed =
    AuthService.isSignedIn() &&
    (AuthService.isAdmin() || role === UserRoles[UserRoles.Veranstalter]);

  if (!isAllowed) {
    return (
      <Navigate to={RoutePaths.SignIn} state={{ from: location }} replace />
    );
  }

  return (
    <div>
      <Header location={location} navigate={navigate} classes={""}  />
      <div className="container mb-4">
        <Outlet/>
      </div>
      <footer className="footer">
        <div className="container">
          <span className="text-muted float-right">{AppRoutes.appVersion}</span>
        </div>
      </footer>
    </div>
  );
};

const PublicLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
 return (<div>
    <Header location={location} navigate={navigate} classes={""}  />
    <div className="container mt-4 mb-4">
      <Outlet />
    </div>
    <footer className="footer">
      <div className="container">
        <span className="text-muted float-right">{AppRoutes.appVersion}</span>
      </div>
    </footer>
  </div>)
};
